<template>
  <div class="post">
    <!-- header -->
    <div class="post_header">
      <!-- title -->
      <div class="card card-body pb-0" style="border-radius: 10px">
        <table class="table" width="100%">
          <tr>
            <td><strong>Title</strong></td>
            <td>{{ post.title || "title" }}</td>
          </tr>
          <tr v-if="product == 1">
            <td><strong>Category</strong></td>
            <td>{{ post.category.title || "" }}</td>
          </tr>
          <tr v-if="product == 3">
            <td><strong>Category</strong></td>
            <td>{{ post.equipmateCategory.title || "" }}</td>
          </tr>
          <tr v-if="product == 4">
            <td><strong>Category</strong></td>
            <td>{{ post.lineniqcategory.title || "" }}</td>
          </tr>

          <tr>
            <td><strong>Published</strong></td>
            <td>{{ post.published === 1 ? "Yes" : "No" }}</td>
          </tr>
          <tr>
            <td><strong>Featured</strong></td>
            <td>
              <span>{{ post.featured === 1 ? "Yes" : "No" }}</span>
            </td>
          </tr>
          <tr>
            <td><strong>Slug</strong></td>
            <td>
              <span>{{ post.slug || "" }}</span>
            </td>
          </tr>
          <tr>
            <td><strong>Total Comments</strong></td>
            <td>{{ post.total_comments || "" }}</td>
          </tr>
        </table>
      </div>

      <!-- buttons [Update, publish|unpublish , delete] -->
      <!-- <div v-if="typeof post.author !== 'undefined'" class="btn-group float-right" role="group"
        aria-label="Basic example">
        <router-link class="btn btn-success" :to="'/posts/update-post/' + this.post.slug">Update</router-link>

        <template>
          <button v-if="post.published == 0" @click="publishing('publish')" type="button"
            class="btn btn-primary btn-sm">
            Publish
          </button>
          <button v-else @click="publishing('unpublish')" type="button" class="btn btn-warning text-dark btn-sm">
            Unpublish
          </button>
        </template>

        <button @click="deletePost" type="button" class="btn btn-danger">
          Delete
        </button>
      </div> -->

      <span class="clearfix d-block mb-3"></span>
    </div>
  </div>
</template>

<script>
import tagsForm from "./tags_form";
import postComment from "./post_comment";
import moment from "moment/moment";
import axios from "axios";
import helpers from "@/helpers";

export default {
  components: {
    postComment,
  },

  data: function (){
    return {
      // post: null
      product: localStorage.getItem('product')
    };
  },

  computed: {
    post: function () {
      return this.$store.getters["posts/post"];
    },

    comments: function () {
      return this.$store.getters["comments/comments"];
    },

    caption: function () {
      if (!!this.post.caption && this.post.caption != "undefined") {
        return this.$baseURL + "/storage/posts/captions/" + this.post.caption;
      } else return this.$baseURL + "/images/default.jpg";
    },

    body: function () {
      if (!this.post.body) {
        return this.post.body.replace(
          /"posts\/images\/.*?\.png/g,
          (imagePath) => {
            return '"' + this.$baseURL + "/storage/" + imagePath.substr(1);
          }
        );
      }
      return "";
    },

  },

  // mounted() {
  //   this.fetchPostAndComments();
  // },

  created() {
    this.fetchPostAndComments();
  },
  methods: {
    fetchPostAndComments() {
      this.page = helpers.getPageQuery();
      this.$store.dispatch('posts/getPost', this.$route.params.post)
      this.$store.dispatch("comments/getPostComments", this.$route.params.post);
    },


  },
};
</script>
